import React from 'react'

const AdminFooter = () => {
  return (
    <footer className="main-footer">
      <strong>Copyright © 2023 - Consultorios Maria Marta Perez Vazquez.</strong>
      Todos los derechos reservados.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0.0
      </div>
    </footer>

  )
}

export default AdminFooter